// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3cdc0962","186":"33eb221c","344":"732b95b0","372":"1212dc5c","377":"a86eeb4a","443":"eee13efd","738":"bd17c854","841":"ef74b0a4","856":"6d2c69de"}[chunkId] + ".chunk.js";
};